import { render, staticRenderFns } from "./blank-question.vue?vue&type=template&id=3e371f06&scoped=true"
import script from "./blank-question.vue?vue&type=script&lang=ts"
export * from "./blank-question.vue?vue&type=script&lang=ts"
import style0 from "./blank-question.vue?vue&type=style&index=0&id=3e371f06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e371f06",
  null
  
)

export default component.exports